<template>
  <el-row class="container_self">
    <el-row class="table_parent">
      <el-row class="add_btn">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="createUser"
          v-if="permissions.indexOf(61) != -1"
          >新增视频广告</el-button
        >
        <el-button
          type="success"
          icon="el-icon-plus"
          size="mini"
          @click="addAdChannel"
          v-if="permissions.indexOf(61) != -1"
          >新增广告渠道</el-button
        >
      </el-row>

      <el-row class="search_parent">
        <!-- <el-row>搜索</el-row> -->
        <!-- <el-input v-model="searchName" clearable placeholder="请输入packageName"></el-input>
                <el-button type="warning" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-form :inline="true" :model="searchForm" size="mini">
          <el-form-item label="包名">
            <el-select
              v-model="searchForm.packageName"
              clearable
              remote
              reserve-keyword
              filterable
              placeholder="请输入包名"
            >
              <el-option
                v-for="item in packages"
                :key="item.packageName"
                :label="item.packageName"
                :value="item.packageName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告播放位置">
            <el-select
              v-model="searchForm.adDisplayType"
              clearable
              placeholder="请选择广告播放位置"
            >
              <el-option label="SPLASH" value="SPLASH"></el-option>
              <el-option label="BANNER" value="BANNER"></el-option>
              <el-option label="SECTION" value="SECTION"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告渠道">
            <el-select
              v-model="searchForm.channelType"
              clearable
              placeholder="请选择广告渠道"
            >
              <el-option
                v-for="(item, index) in channelList"
                :value="item.channelType"
                :label="item.channelType"
                :key="index"
              ></el-option>
              <!-- <el-option label="MiJi" value="MiJi"></el-option>
                            <el-option label="smaato" value="smaato"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="所属客户">
            <el-select
              v-model="searchForm.customerId"
              remote
              reserve-keyword
              filterable
              placeholder="请输入关键词"
              :remote-method="searchPackage"
              @change="choseCustom"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="warning" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <h3 style="width: 100%">SDK 视频广告列表</h3>
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 10px"
          v-loading="loading"
          element-loading-text="加载中，请稍后"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="50"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="所属客户"
            width="200"
            align="center"
            prop="customerName"
          ></el-table-column>
          <el-table-column
            label="应用包名"
            width="250"
            align="center"
            prop="packageName"
          ></el-table-column>
          <el-table-column
            label="广告位置"
            align="center"
            prop="adDisplayType"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="playPosition"
            label="贴片位置"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.playPosition == '-1'">前贴</span>
              <span v-if="scope.row.playPosition == '0'">中贴</span>
              <span v-if="scope.row.playPosition == '1'">后贴</span>
            </template>
          </el-table-column>
          <el-table-column
            label="渠道"
            align="center"
            prop="channelType"
          ></el-table-column>
          <el-table-column
            label="networkCode"
            prop="networkCode"
            align="center"
          ></el-table-column>
          <el-table-column label="状态" align="center" width="50">
            <template slot-scope="scope">
              <span>{{ scope.row.disabled ? "禁用" : "可用" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否测试" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.testMode ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="url" align="center">
            <template slot-scope="scope">
              <el-popover trigger="click" placement="top" width="350">
                <p>{{ scope.row.url }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">查看地址</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="editAd(scope.row)"
                v-if="permissions.indexOf(62) != -1"
                >修改</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="deletetAd(scope.row)"
                v-if="permissions.indexOf(63) != -1"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="this.searchForm.currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="this.searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>

    <el-dialog
      :title="string + '视频广告'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :model="form"
        label-width="120px"
        :rules="rules"
        ref="ruleForm"
        size="mini"
        class="demo-ruleForm"
      >
        <el-form-item label="所属客户">
          <el-select
            v-model="customId"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
            :remote-method="searchPackage"
            @change="choseCustom"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <!-- <el-input type="text" v-model="form.packageName"></el-input> -->
        </el-form-item>
        <el-form-item label="APP 包名">
          <el-select
            v-model="form.packageName"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
          >
            <el-option
              v-for="item in packages"
              :key="item.packageName"
              :label="item.packageName"
              :value="item.packageName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="AdUrl">
          <el-input v-model="form.url" autocomplete="off" @change="urlChange"></el-input>
        </el-form-item>
        <el-form-item label="广告位置" prop="adDisplayType">
          <!-- <el-input  v-model="form.adDisplayType" autocomplete="off"></el-input> -->
          <el-select v-model="form.adDisplayType" clerarable placeholder="请选择广告位置">
            <el-option label="Banner" value="BANNER"></el-option>
            <el-option label="Section" value="SECTION"></el-option>
            <el-option label="Splash" value="SPLASH"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否测试">
          <el-select v-model="form.testMode">
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广告渠道" prop="channelType">
          <el-select
            v-model="form.channelType"
            @change="channelTypeChange"
            placeholder="请选择广告渠道"
          >
            <!-- <el-option v-for="(item,index) in channelList" :label="item.channelType" :value="item.channelType" :key="index"></el-option> -->
            <el-option
              v-for="(item, index) in networkCodeArr"
              :value="item.channelType"
              :label="item.channelType"
              :key="item.id + '_' + index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="NetworkCode">
          <el-select v-model="form.networkCode" disabled>
            <el-option
              v-for="(item, index) in networkCodeArr"
              :value="item.channelType"
              :label="item.channelType"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="是否禁用">
          <el-switch v-model="form.disabled"></el-switch>
        </el-form-item>

        <el-form-item label="贴片类型">
          <!-- <el-input  v-model="form.playPosition" autocomplete="off"></el-input> -->
          <el-select v-model="form.playPosition">
            <el-option label="Preroll" value="-1"></el-option>
            <el-option label="midroll" value="0"></el-option>
            <el-option label="Postroll" value="1"></el-option>
            <el-option label="Stop" value="2"></el-option>
            <el-option label="Overlay" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宽度">
          <el-input v-model="form.width" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="高度">
          <el-input v-model="form.height" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="channelVisible" title="添加渠道">
      <el-form :model="channelForm" label-width="120px" size="mini" class="demo-ruleForm">
        <el-form-item label="渠道类型">
          <el-input type="text" v-model="channelForm.channelType"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="channelVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="createChannel" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
import { analysisUrl } from "@/assets/dateUtils.js";
export default {
  data() {
    return {
      string: "新增",
      total: 0,
      searchForm: {
        adDisplayType: "",
        channelType: "",
        currentPage: 1,
        customerId: "",
        customerName: "",
        // networkCode: "",
        packageName: "",
        pageSize: 20,
        playPosition: "",
        packageName: "",
      },
      tableData: [],
      networkcodeArr: [],
      loading: false,
      dialogFormVisible: false,
      form: {
        url: "",
        adDisplayType: "",
        channelType: "",
        disabled: false,
        packageName: "",
        playPosition: "",
        width: "",
        height: "",
        testMode: 0,
      },
      rules: {},
      edit: false,
      id: "",
      roles: [],
      edit: false,
      customId: "",
      options: [],
      packages: [],
      permissions: JSON.parse(sessionStorage.getItem("permission")),
      channelVisible: false,
      channelForm: {
        channelType: "",
      },
      channelList: [],
    };
  },
  methods: {
    createChannel() {
      axiosPost(
        "/api/ads/channel/add",
        { channelType: this.channelForm.channelType },
        "JSON"
      ).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: `${this.channelForm.channelType}渠道添加成功`,
            type: "success",
          });
          this.channelVisible = false;
        }
      });
    },
    // getChannels(){
    //   axiosGet('/api/ads/channel/list').then(res=>{
    //     if(res.code==0){
    //         this.channelList=res.data;
    //     }
    //   });
    // },
    // channelTypeChange(val) {
    //   this.networkCodeArr.forEach((element) => {
    //     if (val == element.pageValue) {
    //       this.form.networkCode = element.networkCode || "";
    //     }
    //   });
    // },
    addAdChannel() {
      this.channelForm.channelType = "";
      this.channelVisible = true;
    },
    urlChange(url) {
      // console.log(url);
      let obj = analysisUrl(url);
      // let networkCode = "",
      size = [];
      if (obj.iu) {
        const inputString = obj.iu;
        var iuArr = inputString.split("/");
        networkCode = iuArr[1];
      }
      // size=

      this.form = {
        url: url,
        adDisplayType: "",
        channelType: this.form.channelType || "",
        disabled: false,
        packageName: this.form.packageName || "",
        playPosition: obj.unviewed_position_start || 0,
        width: "",
        height: "",
        testMode: this.form.testMode || 0,
      };
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getAdList(this.searchForm);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAdList(this.searchForm);
    },
    search() {
      this.searchForm.currentPage = 1;
      this.searchForm.pageSize = 20;
      this.getAdList(this.searchForm);
    },
    createUser() {
      this.dialogFormVisible = true;
    },
    editAd(item) {
      this.edit = true;
      let obj = JSON.parse(JSON.stringify(item));
      obj.disabled = obj.disabled ? true : false;
      this.searchPackage(item.customerName);
      this.customId = item.customerId;
      this.choseCustom(item.customerId);
      this.form = obj;
      this.id = item.id;
      this.dialogFormVisible = true;
      this.string = "修改";
    },
    deletetAd(item) {
      this.$confirm(`确定要删除ID为 ${item.id} 的这条广告吗？`, "警告", {
        confirmButtonText: "确定",
        closeOnClickModal: false,
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          axiosPost("/api/ads/delete", { id: item.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: `视频广告删除成功`, type: "success" });
              this.getAdList(this.searchForm);
            }
          });
        },
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let addAdRequest = {
            url: this.form.url,
            adDisplayType: this.form.adDisplayType || "",
            channelType:
              this.form.channelType.indexOf("google") != -1
                ? "google"
                : this.form.channelType,
            disabled: this.form.disabled ? 1 : 0,
            packageName: this.form.packageName || "",
            playPosition: this.form.playPosition || 0,
            width: this.form.width || "",
            height: this.form.height || "",
            testMode: this.form.testMode || 0,
          };
          let url = "",
            string;
          if (!this.edit) {
            url = "/api/ads/add";
            string = "新增";
          } else {
            url = "/api/ads/update";
            string = "修改";
            addAdRequest.id = this.id;
            addAdRequest.customerId = this.customId;
          }
          console.log(addAdRequest);
          axiosPost(url, addAdRequest, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: `视频广告${string}成功`, type: "success" });
              this.getAdList(this.searchForm);
              this.dialogFormVisible = false;
              this.edit = false;
              this.id = "";
              this.resetForm("ruleForm");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
      let _this = this;
      this.customId = "";
      this.options = [];
      this.packages = [];
      setTimeout(function () {
        //此定时器是为了防止页面UI抖动，可移除
        _this.showclient = true;
        _this.edit = false;
        _this.form = {
          url: "",
          adDisplayType: "",
          channelType: "",
          disabled: false,
          packageName: "",
          playPosition: "",
          width: "",
          height: "",
          testMode: 0,
        };
      }, 500);
    },
    choseCustom(val) {
      if (val) {
        axiosGet("/api/app_web/list?customerId=" + val).then((res) => {
          if (res.code == 0) {
            let result = res.data.records;
            this.packages = result;
          }
        });
      } else {
        axiosGet("/api/app_web/list", { currentPage: 1, pageSize: 100 }).then((res) => {
          if (res.code == 0) {
            let result = res.data.records;
            this.packages = result;
          }
        });
      }
    },
    searchPackage(keyword) {
      if (keyword) {
        this.getCustomList({ currentPage: 1, pageSize: 20, keyword: keyword });
      }
    },
    async getCustomList(params) {
      await axiosGet(
        "/api/customer/list?currentPage=" +
          params.currentPage +
          "&pageSize=" +
          params.pageSize +
          "&keyword=" +
          params.keyword
      ).then((res) => {
        if (res.code == 0) {
          this.options = res.data.records;
        }
      });
    },
    async getAdList(params) {
      this.loading = true;
      let res = await axiosGet("/api/ads/list", params);
      this.loading = false;
      if (res.code == 0) {
        this.tableData = res.data.records;
        this.total = res.data.total;
        this.choseCustom();
      }
    },
    handleSelect(item) {
      console.log(item);
    },
    getNetworkCode() {
      // /api/gam/account/types
      axiosGet("/api/ads/channel/list").then((res) => {
        if (res.code == 0) {
          // if (res.data.length) {
          //   res.data.forEach((item) => {
          //     if (item.type === "google") {
          //       item.pageValue = item.type + "-" + item.name;
          //     } else {
          //       item.pageValue = item.type;
          //     }
          //   });
          // }
          this.networkCodeArr = res.data || [];
          this.channelList = res.data || [];
        }
      });
    },
  },
  mounted() {
    //  this.getChannels();
    this.getNetworkCode();
    this.getAdList({ currentPage: 1, pageSize: 50, keyword: this.searchName });
    this.choseCustom();
  },
};
</script>
<style scoped>
.add {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  background-color: #2698f1;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/AdManager/googleAdList.vue